export enum DateFormat {
  LONG,
  LONG_NO_YEAR,
  NUMERIC,
  TIME,
  LONG_DATE_TIME_AND_TIME_ZONE,
  INTERNATIONAL_NUMERIC_DATETIME_AND_TIME_ZONE,
}
